/* eslint-disable func-names */
import {
  bueTermineRef,
} from './consts'

export default function (editor, opt = {}) {
  const c = opt
  const bm = editor.BlockManager
  const pfx = c.bueTermineClsPfx
  const style = c.defaultStyle ? `<style>
    .${pfx} {
      text-align: center;
      font-family: Helvetica, serif;
    }

    .${pfx}-block {
      display: inline-block;
      margin: 0 10px;
      padding: 10px;
    }

    .${pfx}-digit {
      font-size: 5rem;
    }

    .${pfx}-endtext {
      font-size: 5rem;
    }

    .${pfx}-cont,
    .${pfx}-block {
      display: inline-block;
    }
  </style>` : ''

  if (c.blocks.indexOf(bueTermineRef) >= 0) {
    bm.add(bueTermineRef, {
      label: c.labelBueTermine,
      category: c.labelBueTermineCategory,
      attributes: { class: 'fa fa-calendar' },
      content: `
        <div class="${pfx}" data-gjs-type="bueTermine"></div>
        ${style}
      `,
    })
  }
}
